<template>
  <div class="content">
    <header-top></header-top>
    <div class="box">
      <div class="find">
        <span>找回密码</span>
        <span @click="handlerLogin">返回登录</span>
      </div>
      <input type="text" placeholder="请输入手机号" class="mobile" />
      <div class="lastInput">
        <input type="text" placeholder="请输入验证码" />
        <button>获取验证码</button>
      </div>
      <div class="new">
        <span>新密码：</span>
        <input type="text" placeholder="请输入新密码" />
      </div>
      <div class="again">
        <span>再次确认密码：</span>
        <input type="text" placeholder="再次确认密码" />
      </div>
      <button class="login">登&nbsp;录</button>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/header.vue";

export default {
  components: {
    headerTop
  },
  data() {
    return {};
  },
  methods: {
    handlerLogin() {
      this.$router.push({
        path: "/login/mobile"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  box-sizing: border-box;
  width: 490px;
  margin: 140px auto 0;
  color: #2e2c2d;
  font-size: 24px;
}
.find {
  margin-bottom: 50px;
  cursor: pointer;
  span {
    margin-right: 90px;
    color: #2e2c2d;
  }
}
input {
  border: 1px solid #a0a0a0;
  outline: none;
  border-radius: 5px;
}
.mobile {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0 10px 20px;
  margin-bottom: 50px;
}
.lastInput {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
  button {
    padding: 5px 8px;
    border: none;
    background-color: #41a5ef;
    color: #fff;
    border-radius: 5px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }
  input {
    width: 360px;
    padding: 10px 0 10px 20px;
  }
}
.new {
  font-size: 18px;
  margin-bottom: 50px;
  input {
    width: 395px;
    padding: 10px 0 10px 20px;
  }
}
.again {
  font-size: 18px;
  margin-bottom: 50px;
  input {
    width: 340px;
    padding: 10px 0 10px 20px;
  }
}
.login {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  border: none;
  background-color: #41a5ef;
  color: #fff;
  border-radius: 5px;
  outline: none;
}
</style>




